import { createSlice } from "@reduxjs/toolkit";
import ServerRoutes from "../api/routes";
import { get, post } from "../api/http";

const initialState = {
  helpers: {},
  todosError: null,
  todosLoading: false,
};

const _addTodo = (state, action) => {
  let editedTodos = { ...state.helpers };
  editedTodos[action.payload.id] = {
    ...action.payload.body,
    _id: action.payload.id,
  };
  state.helpers = editedTodos;
};

const _setTodos = (state, action) => {
  state.helpers = action.payload;
  state.todosLoading = false;
};

const _deleteTodo = (state, action) => {
  let editedTodos = { ...state.helpers };
  delete editedTodos[action.payload];
  state.helpers = editedTodos;
};

const _actionStart = (state) => {
  state.todosLoading = true;
  state.todosError = null;
};

const _actionSuccess = (state) => {
  state.todosLoading = false;
  state.todosError = null;
};

const _actionFailed = (state, action) => {
  state.todosLoading = false;
  state.todosError = action.payload.error;
};

const helpers = createSlice({
  name: "helpers",
  initialState,
  reducers: {
    addTodo: _addTodo,
    setTodos: _setTodos,
    deleteTodo: _deleteTodo,
    actionStart: _actionStart,
    actionFailed: _actionFailed,
    actionSuccess: _actionSuccess,
  },
});

const { reducer, actions } = helpers;

const {
  setTodos,
  addTodo,
  deleteTodo,
  actionStart,
  actionFailed,
  actionSuccess,
} = actions;

export default reducer;

export const getAllH = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(ServerRoutes.Helpers.getAll, {});
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setTodos(data));
  };
};

export const cleanAll = () => {
  return async (dispatch) => {
    dispatch(setTodos({}));
  };
};

export const add = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(ServerRoutes.Helpers.add, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(addTodo({ id: data.id, body }));
    }
  };
};

export const deleteF = (id) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Helpers.delete, { id });
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(deleteTodo(id));
    }
  };
};
